type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export default function PlusIcon({
  color = '#000',
  width = 16.5,
  height = 16.5,
}: Props) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6 44.4h18.8V25.6c0-7.5 11.2-7.5 11.2 0v18.8h18.8c7.5 0 7.5 11.2 0 11.2H55.6v18.8c0 7.5-11.2 7.5-11.2 0V55.6H25.6c-7.5 0-7.5-11.2 0-11.2z"
        fill={color}
        fill-rule="nonzero"
      />
    </svg>
  );
}
